var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRectangleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 3,
  height: 10,
  viewBox: "0 0 3 4",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 0.5,
  width: 3,
  height: 3,
  fill: "#D1D1D1"
})));
export { SvgRectangleIcon as ReactComponent };
export default __webpack_public_path__ + "assets/af4d0148.svg";